import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc component
     * @name pkpExternalTradeDetails
     * @memberof app
     *
     * @description
     * Detail page showing details of one external trade.
     * This is used for the reporting details page as well as for the confirm page when creating an external trade.
     *
     * @author somarten.btc
     */
    angular.module('app').component('pkpExternalTradeDetails', {
        template:
            require('app/_directives/pkp-external-trade-details.component.html'),
        controller: ExternalTradeDetailsController,
        bindings: {
            tradeId: '<?',
            externalTrade: '<?',
            isReport: '<?'
        }
    });

    function ExternalTradeDetailsController(
        $q,
        $routeParams,
        ExternalTrade,
        DATES,
        TransmissionSystemOperator
    ) {
        var vm = this;

        vm.DATES = DATES;
        vm.uiLoadingError = false;
        vm.uiShowSuccessfullyCreatedAlert =
            vm.isReport && $routeParams.action === 'submit';

        vm.$onInit = onInit;

        function onInit() {
            vm.uiLoadingFinished = false;

            if (!angular.isUndefined(vm.externalTrade)) {
                vm.data = vm.externalTrade;
                loadTso();
                translateDirection();
                return;
            }

            var param = {
                id: vm.tradeId
            };

            ExternalTrade.get(
                param,
                function (res) {
                    vm.data = res;
                    loadTso();
                    translateDirection();
                },
                function () {
                    vm.uiLoadingError = true;
                }
            );
        }

        function translateDirection() {
            if (vm.data.direction === 'BUNDLE') {
                vm.data.direction = 'EXIT/ENTRY';
            }
        }

        function loadTso() {
            var promises = [];

            if (vm.data.tsoId0) {
                promises.push(
                    TransmissionSystemOperator.get(
                        { id: vm.data.tsoId0, detailLevel: 'MINIMAL' },
                        function (res) {
                            vm.tso0 = res;
                        }
                    ).$promise
                );
            }

            if (vm.data.tsoId1) {
                promises.push(
                    TransmissionSystemOperator.get(
                        { id: vm.data.tsoId1, detailLevel: 'MINIMAL' },
                        function (res) {
                            vm.tso1 = res;
                        }
                    ).$promise
                );
            }

            $q.all(promises)
                .then(function () {
                    vm.uiLoadingError = false;
                })
                .catch(function () {
                    vm.uiLoadingError = true;
                })
                .finally(function () {
                    vm.uiLoadingFinished = true;
                });
        }
    }
})();
